import { useEffect, useRef } from 'react'
import { realtime } from '../lib/supabase'
import type { Notification } from '../lib/services/notifications'

type RealtimeChannel = ReturnType<typeof realtime.channel>

export function useRealtimeNotifications(
  userId: string | undefined,
  onNewNotification: (notification: Notification) => void,
) {
  const channelRef = useRef<RealtimeChannel | null>(null)

  useEffect(() => {
    if (!userId) return

    if (channelRef.current) {
      realtime.removeChannel(channelRef.current)
    }

    const channel = realtime
      .channel(`notifications-${userId}`)
      .on(
        'postgres_changes' as any,
        {
          event: 'INSERT',
          schema: 'public',
          table: 'notifications',
          filter: `user_id=eq.${userId}`,
        },
        (payload: { new: Record<string, unknown> }) => {
          const row = payload.new
          if (typeof row.notification_id !== 'string') return
          onNewNotification({
            notification_id: row.notification_id,
            tenant_id: typeof row.tenant_id === 'string' ? row.tenant_id : '',
            facility_id: typeof row.facility_id === 'string' ? row.facility_id : null,
            notification_type: typeof row.notification_type === 'string' ? row.notification_type : '',
            title: typeof row.title === 'string' ? row.title : '',
            body: typeof row.body === 'string' ? row.body : '',
            entity_type: typeof row.entity_type === 'string' ? row.entity_type : null,
            entity_id: typeof row.entity_id === 'string' ? row.entity_id : null,
            read_at: null,
            created_at: typeof row.created_at === 'string' ? row.created_at : new Date().toISOString(),
          })
        },
      )
      .subscribe()

    channelRef.current = channel

    return () => {
      if (channelRef.current) {
        realtime.removeChannel(channelRef.current)
        channelRef.current = null
      }
    }
  }, [userId, onNewNotification])
}
